import * as React from 'react';

import axios from '../../api/axios/axiosInstance';
import axiosCartoInstance from "../../api/axios/axiosCartoInstance";
import {useAuthCartoPia} from "components/providers/CartoPiaAuthProvider";
import {useLocation} from "react-router-dom";

// eslint-disable-next-line import/no-cycle
import {useAuth} from '../providers/AuthProvider';
import axiosCartoLayerInstance   from "../../api/axios/axiosCartoLayerInstance";
import useCartoPiaToken from "../../api/hooks/useCartoPiaToken";

// * Maybe we need more than one axios instance
const axiosInstances = [axios];
const axiosCartoInstances = axiosCartoInstance;


const TokenInterceptor = ({children, getAccessToken}) => {
  const {logout, isAuthenticated, isPending} = useAuth();
  const {getCartoPiaAuthenticationToken} = useAuthCartoPia();
  const location = useLocation();
  const {data: cartoPiaToken, refetch: refetchCartoPiaToken} = useCartoPiaToken()

  React.useEffect(() => {
    axiosCartoLayerInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const {response, config} = error;
        const originalRequest = config;
        if ((error.response?.status === 401 && !originalRequest._retry)) {
          originalRequest._retry = true;
          try {
            const result = await refetchCartoPiaToken();
            if (result.status === 'success') {
              const newAccessToken = result.data.accessToken;
              localStorage.setItem('cartoPiaAuthToken', newAccessToken);
              localStorage.setItem('cartoPiaAuthTokenDate', result.data.expirationDate);
              originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
              return axiosCartoLayerInstance(originalRequest);
            } else {
              return Promise.reject(error);
            }
          } catch (refreshError) {
            return Promise.reject(refreshError);
          }
        }
        return Promise.reject(error.response || error);
      }
    );
    axiosCartoInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const {response, config} = error;
        const originalRequest = config;
        if ((error.response?.status === 401 && !originalRequest._retry)) {
          originalRequest._retry = true;
          try {
            const result = await refetchCartoPiaToken();
            if (result.status === 'success') {
              const newAccessToken = result.data.accessToken;
              localStorage.setItem('cartoPiaAuthToken', newAccessToken);
              localStorage.setItem('cartoPiaAuthTokenDate', result.data.expirationDate);
              originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
              return axiosCartoLayerInstance(originalRequest);
            } else {
              return Promise.reject(error);
            }
          } catch (refreshError) {
            return Promise.reject(refreshError);
          }
        }
        return Promise.reject(error.response || error);
      }
    );
    const addResponseInterceptor = (axiosIns) =>
      axiosIns.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          const shouldRefreshToken = isAuthenticated && error.response?.status === 401;
          if (shouldRefreshToken) {
            return logout();
          }
          return Promise.reject(error.response || error);
        }
      );

    const errorInterceptors = axiosInstances.map((instance) => addResponseInterceptor(instance));

    return () => {
      axiosInstances.forEach((instance, i) => {
        instance.interceptors.response.eject(errorInterceptors[i]);
      });
    };
  }, [isAuthenticated, logout]);

  React.useEffect(() => {
    const addRequestInterceptor = (axiosInstance) =>
      axiosInstance.interceptors.request.use(
        (config) => {
          return {
            ...config,
            headers: {
              ...config.headers,
              Authorization: `Bearer ${getAccessToken()}`,
            },
          };
        },
        (error) => Promise.reject(error)
      );

    const authInterceptors = axiosInstances.map((instance) => {
      return addRequestInterceptor(instance);
    });

    return () => {
      axiosInstances.forEach((instance, i) =>
        instance.interceptors.request.eject(authInterceptors[i])
      );
    };
  }, [getAccessToken]);

  React.useEffect(() => {
    if (!getAccessToken) return;
    const cartoRequestInterceptors = axiosCartoInstances.interceptors.request.use(async (config) => {
      const newConfig = {...config}
      newConfig.headers = {
        ...config.headers,
        Authorization: `Bearer ${await getCartoPiaAuthenticationToken()}`,
        'Content-Type': 'application/json'
      }
      return newConfig;
    });
    const cartoLayerRequestInterceptors = axiosCartoLayerInstance.interceptors.request.use(async (config) => {
      const newConfig = {...config}
      newConfig.headers = {
        ...config.headers,
        Authorization: `Bearer ${await getCartoPiaAuthenticationToken()}`,
        'Content-Type': 'application/json'
      }
      return newConfig;
    });
    return () => {
      axiosCartoInstances.interceptors.request.eject(cartoRequestInterceptors);
      axiosCartoLayerInstance.interceptors.request.eject(cartoLayerRequestInterceptors);
    }

  }, [])

  const isLoginView = location.pathname === '/login';

  return  isLoginView ? children : isPending ? null : children;
};

export default TokenInterceptor;
